import React from 'react';
import { Box } from '@mui/material';
import MobileTabBar from './MobileTabBar';

/**
 * MobileShell — root mobile/tablet layout: a scrollable content area and the
 * bottom tab bar. Each screen renders its own <MobileHeader> (sticky) at the
 * top of its content, so headers are prop-driven per section. See
 * MOBILE_PLAN.md §D.
 */
const MobileShell = function MobileShell({ children = null }) {
  return (
    <Box
      sx={{
        height: '100dvh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        bgcolor: 'background.default',
      }}
    >
      <Box
        component="main"
        className="scr"
        sx={{ flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden' }}
      >
        {children}
      </Box>
      <MobileTabBar />
    </Box>
  );
};

export default MobileShell;
